import React from "react";

import UsuarioNoticias from "../UsuarioNoticias/UsuarioNoticias";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { MDBContainer } from "mdb-react-ui-kit";

export class Asistencias extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      noticias: []
    };
  }

  componentDidMount() {
    this.getNoticias();
  }

  getNoticias() {
    this.props.onLoading(true);

    doFetch("HAPK", "getAllNews", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(JSON.stringify(data, null, 2));
        this.setState({ noticias: data.DATA });
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  render() {
    return (
      <MDBContainer>
        {this.state.noticias?.map((element, index) => (
          <UsuarioNoticias
            imagenAutor={element.IDUsuarioFK.userImg}
            nombreAutor={element.IDUsuarioFK.nombre}
            noticia={element.descripcion}
            fecha={element.fecha}
          />
        ))}
      </MDBContainer>
    )
  }

};

export default Asistencias;
